import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
// The backoffice's magnifier assets are drawn in white for dark headers; this matches
// the Feed search's light-grey outline on a white field.
const Magnifier = (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
        <path d="m14.667 14.665-3.148-3.153 3.148 3.153Zm-1.403-7.368a5.965 5.965 0 1 1-11.93 0 5.965 5.965 0 0 1 11.93 0v0Z" stroke="#9392AD" strokeLinecap="round" />
    </svg>
)

/**
 * Search field above the archive filters, styled after the Feed search (same pill,
 * border, type and magnifier). Escape or the clear button empties it.
 */
export default function ArchiveSearch({ value, onChange, busy }) {
    const { t } = useTranslation()
    const inputRef = useRef(null)

    const clear = () => {
        onChange('')
        inputRef.current?.focus()
    }

    return (
        <div className={`archive-search${value ? ' has-value' : ''}`} role="search">
            <input
                ref={inputRef}
                type="search"
                className="archive-search-input"
                value={value}
                maxLength={100}
                placeholder={t('archiveSearchPlaceholder')}
                aria-label={t('archiveSearchPlaceholder')}
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Escape' && value) {
                        event.preventDefault()
                        clear()
                    }
                }}
                autoComplete="off"
                spellCheck={false}
                enterKeyHint="search"
            />
            {busy && <span className="archive-search-spinner" aria-hidden="true" />}
            {!!value && (
                <button type="button" className="archive-search-clear" onClick={clear} aria-label={t('archiveSearchClear')}>
                    <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true" focusable="false">
                        <path d="M1.5 1.5l7 7M8.5 1.5l-7 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                    </svg>
                </button>
            )}
            <Magnifier className="archive-search-icon" aria-hidden="true" focusable="false" />
        </div>
    )
}
